var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"role-permission"},[_c('r-main-panel',[_c('rp-sidebar')],1),_c('rp-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }